import { render, staticRenderFns } from "./QuizProgressTab.vue?vue&type=template&id=1235a8f2&scoped=true&"
import script from "./QuizProgressTab.vue?vue&type=script&lang=js&"
export * from "./QuizProgressTab.vue?vue&type=script&lang=js&"
import style0 from "./QuizProgressTab.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./QuizProgressTab.vue?vue&type=style&index=1&id=1235a8f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1235a8f2",
  null
  
)

export default component.exports